<template>
  <div class="">

    <!-- hero: split — full vector visible + text on solid panel (no overlap) -->
    <section class="heroSection">
      <b-container fluid class="px-0">
        <b-row
          no-gutters
          class="check-self-hero-split intro-section align-items-stretch mx-0"
        >
          <b-col cols="12" xl="6" class="check-self-hero-art p-0" aria-hidden="true" />
          <b-col
            cols="12"
            xl="6"
            class="check-self-hero-copy d-flex align-items-center py-5 px-4 px-xl-5"
          >
            <div class="check-self-hero-text w-100">
              <h1 class="mb-3"><b>{{ langDec.landing_exams_title }}</b></h1>
              <p class="mb-0">{{ langDec.landing_exams_lead_bold }}</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- ceoMessage -->
    <section class="ceoMessage">
      <b-container fluid>
        <b-row class=" justify-content-around">
          <b-col xl="12" lg="12" md="12"
            style="display: flex;align-items: center; justify-content: center;text-align: center;">
            <div class="text-section">
              <div>
                <p class="check-self-quote">
                  {{ langDec.landing_exams_quote }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- info greyBox -->
    <section class="greyBox">
      <b-container fluid>
        <b-row class=" justify-content-around">

          <!-- section -->
          <b-col xl="12" lg="12" md="12" style="display: flex;align-items: center;justify-content: center;">
            <div class="text-section">

              <!-- section -->
              <div style="width: -webkit-fill-available;">
                <div class="title mb-4">
                  <span class="title-green">
                    <b>{{ langDec.check_self_steps_title }}</b>
                  </span>
                </div>
                <b-row class="">
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="greenCol">
                      <div>{{ langDec.check_self_step_1 }}</div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="greenCol">
                      <div>{{ langDec.check_self_step_2 }}</div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="greenCol">
                      <div>{{ langDec.check_self_step_3 }}</div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <br>
              <!-- section -->
              <div style="width: -webkit-fill-available;">
                <div class="title mb-4">
                  <span class="title-green">
                    <b>{{ langDec.check_self_features_title }}</b>
                  </span>
                </div>
                <b-row class="">
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="lightGreenCol">
                      <div>{{ langDec.check_self_feature_1 }}</div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="lightGreenCol">
                      <div>{{ langDec.check_self_feature_2 }}</div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12">
                    <div class="lightGreenCol">
                      <div>{{ langDec.check_self_feature_3 }}</div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- examinations -->
    <section class="examinations-section">
      <b-container fluid>
        <b-row>
          <!-- section -->
          <b-col xl="12" lg="12" md="12" style="display: flex; align-items: center; text-align: center; justify-content: center;">
            <div class="mb-4">
              <p style="font-size: x-large;">
                {{ langDec.check_self_exams_intro }}
              </p>
            </div>
          </b-col>

          <!-- <b-col xl="6" lg="6" md="12" style="display: flex;align-items: center;justify-content: END;">
            <div class="">
              <b-form-group
                v-slot="{ ariaDescribedby }"
              >
                <b-form-radio-group
                class="filter"
                  id="btn-radios-2"
                  v-model="selected"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  button-variant="outline-primary"
                  size="md"
                  name="radio-btn-outline"
                  buttons
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </b-col> -->
        </b-row>


        <b-row>
          <!-- section -->
          <b-col v-for="item in items" :key="item.id" xl="3" lg="3" md="6" sm="12" style="margin-bottom: 30px;">
            <div class="card">
              <b-card no-body>
                <b-card-body class="text-center py-5 my-2">
                  <b-card-title>
                    <img width="250px" height="250px" style="object-fit: cover;"
                      :src="'https://api.takhatty.com/' + item.imageUrl">
                  </b-card-title>

                  <b-card-text>
                    <b :title="item.title"
                      style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;min-height: calc(1em * 1.5 * 2);line-height: 1.5;">
                      {{ item.title }}
                    </b>
                    <br>
                    <div style="display: flex;justify-content: space-around;">
                      <b-badge class="examBadge orangeBadge"><img class="exam-badge-icon" width="15px"
                          src="../assets/images/codicon_question.png">{{ item.questions.length }} {{ langDec.check_self_questions_label }}</b-badge>
                      <b-badge class="examBadge orangeBadge"><img class="exam-badge-icon" width="15px"
                          src="../assets/images/wi_time-7.png">{{ item.questions.length * 0.5 }} {{ langDec.check_self_minutes_label }}</b-badge>
                    </div>
                  </b-card-text>

                </b-card-body>
              </b-card>
            </div>
          </b-col>


        </b-row>
      </b-container>
    </section>



    <section class="">
      
    </section>    

    

    <!-- exams -->
    <section class="exams flex" :class="{ 'exams--en': !isAr }">
      <div>
        <div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="header">
                <div class="section-header">
                  <h2>{{ langDec.landing_exams_title }}</h2>
                  <div class="description">
                    <br>
                    <p>
                      {{ langDec.check_self_app_lead }}
                    </p>
                    <p><b>{{ langDec.landing_download_app }}</b></p>
                    <div class="description">
                      <p v-if="!googleplay && !applestore" style="color: red;">
                        <b>{{ langDec.articles_app_unavailable }}</b>
                        <br>

                        <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                          <span>{{ langDec.articles_contact_us }}</span>
                        </b-button>
                      </p>
                    </div>
                  </div>

                  <div v-if="googleplay || applestore" class="action-btns mt-5">
                    <b-button v-if="applestore" class="px-4 py-3 mx-4 my-3" @click="goTowebsite(applestore)"
                      style="background-color: black;color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner carousel-btn-in-div px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                          <img class="store-badge-inner__apple-img"
                            src="../assets/images/Apple_logo_white.svg.png" alt="">
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text check-self-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>

                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--google">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text check-self-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!--Featured Articles-->
    <section>
      <articles :seeMoreBtn="true" :loadMore="false" :pageSize="4" cols="3"
        :title="langDec.landing_patients_title"
        :info="langDec.landing_patients_info"></articles>
    </section>


  </div>
</template>


<script>
import { mapGetters } from "vuex"
import articles from "../components/ArticlesSection.vue"
import { sendRequest } from '../utils/RequestHelper.js'


export default {
  name: 'Home',
  data() {
    return {
      selected: 'all',
      options: [
        { text: 'كل الاختبارات', value: 'all' },
        { text: 'إختبارات للكِبار', value: 'adults' },
        { text: 'إختبارات للمراهقين والأطفال', value: 'kids' }
      ],
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      items: []
    }
  },

  components: {
    articles
  },

  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {}
    },
    isAr() {
      return this.getlang === "ar"
    },
  },

  methods: {
    goToRoute(name) {
      this.$router.push({
        name,
      }).catch(() => { });
    },
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    loadData() {
      this.pageIsLoading = true;
      let body = {
        pageNumber: 1,
        pageSize: 9999
      }
      this.pageIsLoading = true;
      sendRequest('post', 'exams/search', true, body,
        (response) => {
          this.items = response.data.data.items;
          console.log(this.items);

          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
          this.alertType = 'danger';
          this.alertText = this.langDec.errorMessage || 'Error loading data';
        }
      );
    }
  },
  created() {
    this.loadData();
  }
}
</script>

<style scoped>
.check-self-quote {
  white-space: pre-line;
  text-align: start;
}

/* Split hero: art column = full-bleed crop of illustration; copy column = solid green, no overlay on vector */
.heroSection .check-self-hero-split {
  min-height: 450px;
}

.check-self-hero-art {
  min-height: 280px;
  background-color: #0d7a45;
  background-image: url(../assets/images/checkGreenBG.png);
  background-size: cover;
  background-repeat: no-repeat;
  /* Figure is on the left of the source image — same anchor for AR + EN so RTL column
     on the right still shows the full vector (right anchor was clipping the figure). */
  background-position: left center;
}

.check-self-hero-copy {
  background: linear-gradient(160deg, #054d2a 0%, #006633 42%, #0a7a44 100%);
  color: #fff;
}

.check-self-hero-text {
  text-align: start;
}

.check-self-hero-text h1 {
  font-size: 2.25rem !important;
  font-weight: bolder !important;
  line-height: 1.2;
  color: #fff !important;
}

.check-self-hero-text p {
  font-size: 1.125rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96) !important;
}

@media (min-width: 1200px) {
  .check-self-hero-art {
    min-height: 450px;
  }

  .check-self-hero-text h1 {
    font-size: 2.5rem !important;
  }

  .check-self-hero-text p {
    font-size: 1.2rem;
  }
}

@media (max-width: 991.98px) {
  .heroSection .check-self-hero-split {
    min-height: 0;
  }

  .check-self-hero-art {
    min-height: 260px;
  }
}

@media (max-width: 767.98px) {
  .check-self-hero-art {
    min-height: 220px;
  }
}

.exams {
  background-image: url('../assets/images/examsBG.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
  color: white;
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 22px;
}

.exams--en {
  background-position: left center;
}

.exams .description {
  font-size: 17px;
}

.exams .action-btns .btn {
  color: #006633 !important;
}

/* ceoMessage */
.ceoMessage {
  padding: 80px 20px;
}

.ceoMessage .text-section {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 20px;
  width: 65%;
}

.ceoMessage .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.ceoMessage .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.ceoMessage .text-section .pref {
  font-size: 16px;
  color: #858585;
}

.ceo .text-section p {
  margin-top: 30px;
}


/* greyBox */
.greyBox,
.examinations-section {
  margin-bottom: 50px;
  padding: 20px 50px;
}

.greyBoxSection {
  padding: 20px 40px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px 30px;
  width: 100%;
  text-align: start;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.greyBox .text-section .pref {
  font-size: 16px;
  color: #858585;
}

.greenCol {
  background-color: #5EB47C;
  padding: 20px;
  border-radius: 10px;
  color: white;
  margin-bottom: 10px;
  min-height: 89px;
  display: flex;
  align-items: center;
}

.lightGreenCol {
  border: 1px solid#5EB47C;
  padding: 20px;
  border-radius: 10px;
  color: black;
  margin-bottom: 10px;
  min-height: 89px;
  display: flex;
  align-items: center;
}

.examinations-section .card {
  background-color: #f7f7f7;
}

.examBadge {
  padding: 5px 10px;
  font-weight: 100;
  margin-top: 20px;
}

.exam-badge-icon {
  margin-inline-end: 0.5rem;
}

/* App store badges — EN: text | icon */
.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.check-self-store-text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}

@media (max-width: 991.98px) {

  .text-section h2 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .button-section .btn {
    font-size: 10px !important;
  }

  .ceo .text-section {
    margin-right: 30px;
    margin-bottom: 50px;
  }

  .ceoMessage .text-section {
    padding: 10px;
    width: 80%;
  }

  .greyBox {
    padding: 10px;
  }

  .greyBoxSection .examinations-section {
    padding: 10px 0px;
  }

  .greyBox .text-section {
    padding: 20px;
  }

  .examinations-section {
    padding: 10px;
  }
}

@media (max-width: 767.98px) {
  .ceoMessage .text-section {
    width: 95%;
  }

  .greyBoxSection .examinations-section {
    padding: 10px 0px;
  }

  .examinations-section {
    padding: 10px;
  }
}
</style>